module.exports = __webpack_public_path__ + "img/reembolso.19d751ed.png";